import { Component, Inject, Input, EventEmitter, Output, ViewChild } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { CommandRelay } from '../../../../shared/commands/command-relay.class';

import { MultiFilterableSelectComponent } from '../../../../shared/filterable-select/components/multi-filterable-select.component';

import { ParcService } from '../services/parc.service';
import { ParcTLR } from '../entities/parc-tlr.entity';

@Component({
	selector: 'parc-multi-selector',
	templateUrl: 'parc-multi-selector.html',
})
export class ParcMultiSelectorComponent {
	parcs!: ParcTLR[];

	getParcLabel = (parc: ParcTLR) => parc.code + ' (' + (parc.description ? parc.description : '') + ')';
	
	changeSelectionCommands = new Subject<(item: any, isSelected: boolean) => boolean>();

	constructor( //
		@Inject(ParcService) private parcService: ParcService //
	) {
	}

	@ViewChild(MultiFilterableSelectComponent) input!: MultiFilterableSelectComponent;

	@Input() id!: string;
	@Input() disabled = false;
	@Input() maxNumberOfSelections: number | null = null;
	
	// Classes pour l'affichege
	public _labelClass: string = 'col-md-1';
	@Input() set labelClass(value: string | undefined) {
		if (value) {
			this._labelClass = value;
		}	
	}
	get labelClass(): string | undefined {
		return this._labelClass;
	}
	
	public _fieldClass: string = 'col-md-7';
	@Input() set fieldClass(value: string | undefined) {
		if (value) {
			this._fieldClass = value;
		}
	}
	get fieldClass(): string | undefined {
		return this._fieldClass;
	}

	private _antenneId!: number | null | undefined;
	@Input() set antenneId(antenneId: number | null | undefined) {
		if (this._antenneId != antenneId || !this.parcs) {
			this._antenneId = antenneId;
			this.parcs = [];
			
			let parcs$ = antenneId ?
				this.parcService.getParcTLRByAntenne(antenneId)
				:
				this.parcService.getParcTLRList()
			;
			
			parcs$.subscribe(
				(parcs : ParcTLR[]) => this.parcs = parcs
			);
		}
	}
	
	private _selectedParcIds: number[] = [];
	@Input() set selectedParcIds(ids: number[] | undefined) {
		if (ids != undefined) {
			this._selectedParcIds = ids;
		}
	}
	get selectedParcIds(): number[] | undefined {
		return this._selectedParcIds;
	}
	
	private clearCommandsRelay = new CommandRelay<void>(() => this.changeSelectionCommands.next((_item: any, _isSelected: boolean) => false));
	@Input() set clearCommands(obs: Observable<void>) {
		this.clearCommandsRelay.register(obs);
	} 
	
	@Output() selectedParcIdsChange = new EventEmitter<number[]>();
	
	@Output() selectedParcsChange = new EventEmitter<ParcTLR[]>();
	
	onSelectedParcsChange(parcs: ParcTLR[]) {
		let ids = parcs.map((parc: ParcTLR) => parc.id);
		this._selectedParcIds = ids;
		this.selectedParcIdsChange.emit(ids);
		this.selectedParcsChange.emit(parcs);
	}
}